import { Modal } from "bootstrap";
import { IconText } from "components/IconText";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { RouteList } from "Routes";
import { Constants } from "utils/Constants";

export const CheckInModal = () => {
    const modalRef = useRef<HTMLDivElement>(null);

    const [feedback, setFeedback] = useState<boolean>();

    const submitGoodFeedback = () => {
        setFeedback(true);
    };

    const submitBadFeedback = () => {
        setFeedback(false);
    };

    const onComplete = () => {
        if (modalRef.current) {
            const modal = Modal.getOrCreateInstance(modalRef.current);

            modal.hide();
        }
    };

    useEffect(() => {
        if (modalRef.current) {
            const modal = Modal.getOrCreateInstance(modalRef.current);

            modal.show();

            return () => {
                modal.hide();
            };
        }
    }, []);

    return (
        <div className="modal fade" ref={modalRef}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white">
                        <h2 className="h4">
                            {feedback === false ? "Oh no! What happened? 😰" : "Big game! How did it go?"}
                        </h2>

                        <button type="button" className="btn-close" aria-label="Close" onClick={onComplete}></button>
                    </div>

                    <div className="modal-body">
                        {feedback === undefined ? (
                            <div className="d-flex justify-content-center gap-3">
                                <button
                                    type="button"
                                    id="btn-check-in-positive"
                                    className="btn btn-lg btn-success rounded-pill"
                                    onClick={submitGoodFeedback}
                                >
                                    <span className="fas fa-thumbs-up"></span>
                                </button>

                                <button
                                    type="button"
                                    id="btn-check-in-negative"
                                    className="btn btn-lg btn-danger rounded-pill"
                                    onClick={submitBadFeedback}
                                >
                                    <span className="fas fa-thumbs-down"></span>
                                </button>
                            </div>
                        ) : feedback === true ? (
                            <div className="vstack gap-3">
                                <div className="vstack gap-2">
                                    <h3 className="h4">Great! 🥰</h3>

                                    <div>
                                        If you have any feedback feel free to{" "}
                                        <Link to={RouteList.Contact}>contact us</Link> .
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="vstack gap-4">
                                <div className="vstack gap-2">
                                    <h3 className="h4">Derailed by players?</h3>

                                    <div>
                                        🧑‍🏫 <Link to={RouteList.Pricing}>Frankenstories Pro</Link> gives you more
                                        control!
                                    </div>
                                </div>

                                <div className="vstack gap-2">
                                    <h3 className="h4">Players struggled?</h3>

                                    <div>
                                        💪 Find scaffolding ideas in{" "}
                                        <a target="_blank" href={Constants.lessonTeachingWithFrankenstories}>
                                            Teaching with Frankenstories
                                        </a>
                                        .
                                    </div>
                                </div>

                                <div className="vstack gap-2">
                                    <h3 className="h4">Gameplay issue?</h3>

                                    <div>
                                        🐞 <Link to={RouteList.Contact}>Tell us what happened</Link> and we'll try to
                                        fix it.
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {feedback !== undefined && (
                        <div className="modal-footer justify-content-start d-flex gap-2 align-items-center">
                            <button type="button" className="btn btn-primary icon-link" onClick={onComplete}>
                                <IconText icon="fas fa-eye" text="View story" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
